<template>
	<div class="Finances">
		<vs-prompt
			@cancel="date = ''"
			@accept="removePayout"
			:active.sync="activePrompt2"
			:title="$t('rejectPayment')"
			:acceptText="$t('decline')"
			color="danger"
			:cancelText="$t('cancel')"
		>
			<div class="flex items-end">
				<div class="vx-col w-full">
					<div class="vs-component vs-con-input-label vs-input vs-input-primary w-full">
						<label class="vs-input--label">{{ $t('paymentRejectingReason') }}</label>
						<div class="vs-con-input">
						</div>
						<vs-textarea class="w-full" v-model="about" name="about" v-validate="'required|min:3'"/>
					</div>
					<span class="text-danger text-sm">{{ errors.first('about') }}</span>
				</div>
			</div>
		</vs-prompt>
		<div class="vx-row items-center" v-if="$store.state.auth.role !== 'admin'">
			<div class="vx-col lg:w-1/4 w-full mb-10">
				<vx-card>
					<div class="flex justify-between items-center box-top">
						<div class="des w-full">
							<b>{{ incomes }} Є</b>
							<p>{{ $t('currentBalance') }} </p>
						</div>
						<div class="icon ml-3">
							<feather-icon icon="CreditCardIcon"></feather-icon>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="vx-col lg:w-3/4 w-full mb-10">
				<div class="buttons flex justify-end ">
					<vs-button color="success" @click="activePrompt = true">{{ $t('withdraw') }}</vs-button>
				</div>
			</div>
		</div>

		<vx-card class="my-8">
			<vs-tabs v-if="tabs.length > 0">
				<vs-tab
					v-for="tab in tabs"
					:key="tab.title"
					:value="indexTab"
					:label="$t(tab.title)"
				>
					<div class="filter">
						<v-select v-model="user"
								  style="min-width: 170px;margin-right: 20px"
								  v-if="$store.state.auth.role === 'admin'"
								  :options="clients" :reduce="country => country.id" label="last_name"/>
						<div class="date vx-row">
							<vx-input-group class="vx-col">
								<div
									class="vs-component vs-con-input-label vs-input vs-input-primary"
								>
									<div class="vs-con-input"></div>
									<vs-datepicker
										v-model="off"
										format="dd.MM.yyyy"
										:placeholder="$t('from')"
										name="date"
									></vs-datepicker>
								</div>
							</vx-input-group>
							<vx-input-group class="vx-col">
								<div
									class="vs-component vs-con-input-label vs-input vs-input-primary"
								>
									<div class="vs-con-input"></div>
									<vs-datepicker
										v-model="to"
										format="dd.MM.yyyy"
										:placeholder="$t('to')"
										name="date"
									></vs-datepicker>
								</div>
							</vx-input-group>
							<div class="vx-col">
								<vs-custom-button
									color="dark"
									type="border"
									@click="(off = ''), (to = '')"
								>{{ $t('reset') }}
								</vs-custom-button>
							</div>
						</div>
					</div>
					<div class="tab-text">
						<div class="tab-text">
							<tableFinances
								:tab="tab"
							/>
						</div>
					</div>
				</vs-tab>
			</vs-tabs>
		</vx-card>
		<vs-prompt
			@cancel="date = ''"
			@accept="createTask"
			:active.sync="activePrompt"
			:title="$t('payRequest')"
			color="success"
			:acceptText="$t('save')"
			:cancelText="$t('cancel')"
		>
			<div class="con-exemple-prompt">
				<vs-input
					v-model="amount"
					name="amount"
					:label="$t('writeHowMuchYouWantToWithdraw')"
					v-validate="'required|min:1'"
					color="success"
				/>
				<span v-if="errors.first('amount')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import moment from 'moment'
import vSelect from 'vue-select'
import tableFinances from "@/views/Finances/tableFinances.vue";

export default {
	name: "mainFinances",
	mixins: [databaseManager, notifier],
	components: {
		'v-select': vSelect,
		tableFinances,
	},
	data() {
		return {
			pagePath: null,
			user: '',
			clients: [],
			incomes: 0,
			idOrder: 0,
			date: "",
			off: "",
			indexTab: 0,
			to: "",
			about: "",
			amount: 0,
			search: "",
			activePrompt: false,
			activePrompt2: false,
			popupActiv: false,
			task: {},
			tabs: [
				'new',
				'in_progress',
			],
			orders: {
				request: [],
				history: [],
			},
			subjects: [],
			works: [],
			levels: [],
			tasks: [],
			field: [],

			model: {}
		};
	},
	watch: {
		off() {
			this.filter();
		},
		to() {
			this.filter();
		},
		user() {
			this.filter();
		}
	},
	methods: {
		filter() {
			let options = '&';
			if (this.off) options += 'filter[date_from]=' + moment(this.off).format('YYYY-MM-DD') + '&'
			if (this.to) options += 'filter[date_to]=' + moment(this.to).format('YYYY-MM-DD') + '&'
			if (this.user) options += 'filter[user]=' + this.user + '&'

			this.tabs.forEach((item) => {
				this.getTickets(item.key, options);
			});
		},
		async removePayout() {
			try {
				await this.$http.post(
					"/admin/payout/cancel/" + this.model.id,
					{status_message: this.about}
				);

				this.notifySuccess(this.$t('rejectSuccessfully'));

				this.about = "";
				this.popupActiv = false;

				this.tabs.forEach((item) => {
					this.getTickets(item.key);
				});

			} catch (e) {
				if (e.errors) {
					Object.values(e.errors).forEach(err => {
						this.notifyError(err);
					})
				} else {
					this.notifyError(e.message);
				}
			}
		},
		async payout(id, tab, index) {
			try {
				await this.$http.post(
					"/admin/payout/confirm/" + id
				);
				this.notifySuccess(this.$t('completedSuccessfully'));
				this.popupActiv = false;
				this.orders[tab.key].splice(index, 1);

			} catch (e) {
				if (e.errors) {
					Object.values(e.errors).forEach(err => {
						this.notifyError(err);
					})
				} else {
					this.notifyError(e.message);
				}
			}
		},
		showCancelDialog(item) {
			this.activePrompt2 = true;
			this.model = item;
		},
		async createTask(id) {
			try {
				if(!this.amount) return;

				let formData = {
					amount: this.amount,
				};

				await this.$http.post(
					"/" + this.$store.state.auth.role + "/payout/create/",
					formData
				);

				this.notifySuccess(this.$t('addedSuccessfully'));
				this.amount = 0;
				this.popupActiv = false;
				this.tabs.forEach((item) => {
					this.getTickets(item.key);
				});

			} catch (e) {
				if (e.errors) {
					Object.values(e.errors).forEach(err => {
						this.notifyError(err[0]);
					})
				} else {
					this.notifyError(e.message);
				}
			}
		},
		deepFind(obj, path) {
			if (!path) return "";
			let paths = path.split("."),
				current = obj,
				i;

			for (i = 0; i < paths.length; ++i) {
				if (current[paths[i]] === undefined) {
					return undefined;
				} else {
					current = current[paths[i]];
				}
			}
			return current;
		},
		async getTickets(type, options) {
			try {
				let layout = this.$store.state.layout.layout.toLowerCase();
				let url = options && options.length > 2
					? "/" + layout + "/payout?tab=" + type + options
					: "/" + layout + "/payout?tab=" + type;

				if(url[url.length - 1] === '&') url = url.substr(0, url.length - 1);

				this.orders[type] = (
					await this.$http.get(url)
				).data.data;
			} catch (e) {
				this.notifyError(e.message);
			}
		},
		async updateInfoRealtime() {
			if(this.pagePath !== this.$route.fullPath) { return; }

			if (this.$store.state.auth.role !== "admin") {
				let balance = (await this.$http.get('/' + this.$store.state.auth.role + '/stats/get-balance')).data.data.amount;
				this.incomes = balance.toFixed(2);
			} else {
				this.clients = (await this.$http.get('/admin/client')).data.data;
			}

			this.levels = (
				await this.$http.get("/settings/get-quality-levels")
			).data.data;
			this.works = (await this.$http.get("/settings/get-work-types")).data.data;
			this.subjects = (await this.$http.get("/settings/get-subjects")).data.data;
			this.tabs.forEach((item) => {
				this.getTickets(item.key);
			});
		}
	},
	async created() {
		if (this.$store.state.auth.role === "author") {
			this.field = [
				{
					field: "created",
					title: this.$t('date'),
					align: 'center',

				},
				{
					field: "transaction_uid",
					title: this.$t('idTransaction'),
					align: 'center',
				},
				{
					field: "amount",
					title:`${this.$t('sum')}, Є`,
					align: 'center',
				},
				{
					field: "payment_system",
					title: this.$t('paymentSystem'),
					align: 'center',
				},
				{
					field: "status",
					title: this.$t('status'),
					align: 'center',
				},
			];

			this.tabs = [
				{
					key: "request",
					title: this.$t('paymentRequests'),
				},
				{
					key: "history",
					title: this.$t('paymentsHistory'),
				},
			];
		}
		if (this.$store.state.auth.role === "manager") {
			this.field = [
				{
					field: "created",
					title: this.$t('date'),
					align: 'center',
					width: '20%'

				},
				{
					field: "transaction_uid",
					title: this.$t('idTransaction'),
					align: 'center',
					width: '20%'
				},
				{
					field: "amount",
					title: `${this.$t('sum')}, Є`,
					align: 'center',
					width: '20%'
				},
				{
					field: "payment_system",
					title: this.$t('paymentSystem'),
					align: 'center',
					width: '20%'
				},
				{
					field: "status",
					title: this.$t('status'),
					align: 'center',
					width: '20%'
				},
			];

			this.tabs = [
				{
					key: "request",
					title: this.$t('paymentRequests'),
				},
				{
					key: "history",
					title: this.$t('paymentsHistory'),
				},
				{
					key: "historyOrders",
					title: this.$t('paymentsHistoryOrders'),
				},
			];
		}
		if (this.$store.state.auth.role === "admin") {
			this.field = [
				{
					field: "user",
					title: this.$t('user'),
					align: 'center',
					width: '12%'

				},
				{
					field: "created",
					title: this.$t('date'),
					align: 'center',
					width: '12%'

				},
				{
					field: "transaction_uid",
					title: this.$t('idTransaction'),
					align: 'center',
					width: '12%'
				},
				{
					field: "amount",
					title: `${this.$t('sum')}, Є`,
					align: 'center',
					width: '12%'
				},
				{
					field: "payment_system",
					title: this.$t('paymentSystem'),
					align: 'center',
					width: '12%'
				},
				{
					field: "status",
					title: this.$t('status'),
					align: 'center',
					width: '12%'
				},
				{
					field: "actions",
					title: this.$t("actions"),
					align: 'center',
					width: '12%'
				},
			];

			this.tabs = [
				{
					key: "request",
					title: this.$t('paymentRequests'),
				},
				{
					key: "history",
					title: this.$t('paymentsHistory'),
				}, {
					key: "canceled",
					title: this.$t('rejectedPayments'),
				},
			];
		}
	},
	async mounted() {
		this.pagePath = this.$route.fullPath;
		await this.updateInfoRealtime();
	},
};
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables.scss";
@import "../../assets/scss/vuexy/functions.scss";

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}

.inputInTable {
	border: 0;
	resize: none;
}

.fade-enter, .fade-leave-to
{
	opacity: 0;
}

th.justify-center div {
	justify-content: center;
}

.con-vs-tabs {
	overflow: visible;
}

.buttons {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	@media screen and (max-width: 375px) {
		button {
			margin: 5px 0;
		}
	}
}

.vs-tabs--content {
	padding: 0;
	margin-top: 10px;
}

.vs-con-table .vs-con-tbody {
	border: 0;
	background-color: transparent;
}

.con-exemple-prompt {
	.append-text {
		height: 2.7rem;
	}

	.vs-button {
		border-left: 0;
	}

	.vx-input-group-append {
		align-items: flex-end;
	}

	.vs-input {
		width: 100%;

		textarea {
			resize: none;
		}
	}
}

.vs-table {
	margin-top: 10px;

	tr {
		border-top: 1px solid #cfcfcf;

		&:last-child {
			border-bottom: 1px solid #cfcfcf;
		}
	}
}

.con-vs-tabs .con-slot-tabs {
	overflow: visible;
}

.task {
	background-color: #3ac47d;
	border-radius: 10px;
	padding: 4px 10px;
	color: white;
}

.counter {
	display: inline-block;
	padding: 5px;
	border-radius: 100%;
	font-weight: 600;
	width: 20px;
	height: 20px;
	font-size: 0.7rem;
	border: 1px solid #cfcfcf;
	display: flex;
	align-items: center;
	justify-content: center;
	line-height: 1;

	&.warn {
		background-color: #f0ad4e;
		color: white;
		border-color: #f0ad4e;
	}
}

.viewTask {
	.vs-popup--title h3 {
		color: $primary;
	}

	.vs-popup--content {
		padding: 0;
	}

	table {
		width: 100%;

		td {
			padding-bottom: 4px;
		}
	}

	.body {
		padding: 1rem;

		table {
			margin-left: -2px;
		}

		p {
			padding-top: 10px;
			font-size: rem(14px);
		}
	}

	.footer {
		border-top: 1px solid rgba(0, 0, 0, 0.05);
		padding: 0.5rem 1rem;
		display: flex;
		justify-content: flex-end;

		button {
			margin-left: 10px;
		}
	}
}

.filter {
	border-bottom: 1px solid #e5e5e5;
	padding-bottom: 1rem;
	padding-top: 0.5rem;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-wrap: wrap;

	.date {
		display: flex;
		align-items: center;
	}

	.vx-input-group .vx-input-group-default .vs-input {
		width: 150px;
	}

	.search .vs-icon {
		height: 100%;
		width: 35px;
		background: $primary;
		position: absolute;
		top: 0;
		right: 0;
		color: white !important;
		display: flex;
		align-items: center;
		justify-content: center;
		border-top-right-radius: 4px;
		border-bottom-right-radius: 4px;
		font-size: 22px;
	}

	.search .vs-con-input-label {
		width: 270px;
	}
}

.Finances {
	.buttons {
		justify-content: flex-end;
	}

	.button-task {
		border-radius: 22px;
		padding: 0.25rem 0.7rem !important;
	}

	.transfer-status {
		font-weight: 600;

		&_warn {
			color: #efbb40
		}

		&_success {
			color: #4ba44d
		}

		&_failed {
			color: red
		}
	}
}

.finances-status-dropdown {
	margin-left: 9px !important;
}
</style>
